/**
 * @module geo/middleware
 */
import {Action} from 'redux';
import {Epic} from 'redux-observable';
import {Observable} from 'rxjs';
import {Action as ActionFsa, isType} from 'typescript-fsa';

import {addMarkersAsyncCreator, addMarkersCreator, gotoMarkerAsyncCreator, gotoMarkerCreator, removeMarkersAsyncCreator, removeMarkersCreator} from '../actions/creators';
import busService from '../bus';
import {ADD_MARKERS} from '../payload/facade/ADD_MARKERS';
import {GO_TO_MARKER} from '../payload/facade/GO_TO_MARKER';
import {REMOVE_MARKERS} from '../payload/facade/REMOVE_MARKERS';
import {AddMarkersDone} from '../payload/response/addmarkers.done';
import {AppStore} from '../store/app';

/**
 * @private
 *
 */
export const addMarkersEpic: Epic<Action, AppStore> = (action$, store, uid) =>
    action$.filter(action => isType(action, addMarkersCreator))
        .mergeMap((action) => {
          const actionFsa = action as ActionFsa<ADD_MARKERS>;
          return Observable
              .fromPromise(busService.geoBus.sendP<AddMarkersDone>(
                  addMarkersAsyncCreator.type, actionFsa.payload,
                  store.getState().uid))
              .map(result => addMarkersAsyncCreator.done({
                result: {markers: result.data.markers, done: true},
                params: actionFsa.payload
              }))
              .catch(error => {
                return Observable.of(addMarkersAsyncCreator.failed(
                    {params: actionFsa.payload, error}));
              });
        });
/**
 * @private
 *
 */
export const removeMarkersEpic: Epic<Action, AppStore> =
    (action$, store, uid) =>
        action$.filter(action => isType(action, removeMarkersCreator))
            .mergeMap((action) => {
              const actionFsa = action as ActionFsa<REMOVE_MARKERS>;
              return Observable
                  .fromPromise(busService.geoBus.sendP<any>(
                      removeMarkersAsyncCreator.type, actionFsa.payload,
                      store.getState().uid))
                  .map(result => removeMarkersAsyncCreator.done({
                    result: {markers: result.data.markers, done: true},
                    params: actionFsa.payload
                  }))
                  .catch(error => {
                    return Observable.of(removeMarkersAsyncCreator.failed(
                        {params: actionFsa.payload, error}));
                  });
            });
/**
 * @private
 *
 */
export const gotoMarkerEpic: Epic<Action, AppStore> = (action$, store, uid) =>
    action$.filter(action => isType(action, gotoMarkerCreator))
        .mergeMap((action) => {
          const actionFsa = action as ActionFsa<GO_TO_MARKER>;
          return Observable
              .fromPromise(busService.geoBus.sendP<any>(
                  gotoMarkerAsyncCreator.type, actionFsa.payload,
                  store.getState().uid))
              .map(
                  result => gotoMarkerAsyncCreator.done(
                      {result: {done: true}, params: actionFsa.payload}))
              .catch(error => {
                return Observable.of(gotoMarkerAsyncCreator.failed(
                    {params: actionFsa.payload, error}));
              });
        });
